import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

import {
  CheckoutLayout,
  Title,
  SecurityStatement,
  CheckoutInner
} from 'common/components/layout';
import Questions from 'profile/login/Questions';
import { getCustomer } from 'redux/customer/actions';

import ContinueAsGuest from './components/ContinueAsGuest';
import ReturningCustomer from './components/ReturningCustomer';

class Login extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
  }

  render() {
    const { settings, match } = this.props;
    const { slug } = match.params;
    if (!settings.data) {
      return (
        <CheckoutLayout title="Club Login" loading showSideCart={false}>
          <CheckoutInner>
            <Title>Club Login</Title>
          </CheckoutInner>
        </CheckoutLayout>
      );
    }
    return (
      <CheckoutLayout title="Club Login" showSideCart={false}>
        <CheckoutInner settings={settings}>
          <Title>Club Login</Title>
          <div className="c7-account-login">
            <ReturningCustomer slug={slug} />
            <ContinueAsGuest settings={settings} />
          </div>
          <SecurityStatement settings={settings} />
          <Questions settings={settings} />
        </CheckoutInner>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
  settings: state.setting
});

export default connect(mapStateToProps, { getCustomer })(Login);
